export enum AFTER_LOGIN_ACTION {
    EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
    PAYMENT = 'PAYMENT',
    LOGIN_ONLY = 'LOGIN_ONLY',
    MOBILE_OTP = 'MOBILE_OTP'
  }
